/** AdminShell scrolls its `<main>`, not the window, so page-level scrolling goes through it. */
export function scrollAdminMainToTop(behavior: ScrollBehavior = 'auto'): void {
  document.querySelector('.app-hub-main')?.scrollTo({ top: 0, behavior });
}

const ANCHOR_SETTLE_MS = 3000;
const READER_SCROLL_EVENTS = ['wheel', 'touchstart', 'keydown', 'pointerdown'] as const;

/**
 * Scrolls to the element with `id` and keeps it there while the content above it
 * finishes loading, until the reader scrolls or a few seconds pass. Returns the cleanup.
 */
export function keepAnchorInView(id: string, content: Element): () => void {
  const scroll = () => document.getElementById(id)?.scrollIntoView({ block: 'start' });
  scroll();
  if (typeof ResizeObserver === 'undefined') return () => undefined;
  const observer = new ResizeObserver(scroll);
  observer.observe(content);
  const stop = () => {
    observer.disconnect();
    window.clearTimeout(timer);
    READER_SCROLL_EVENTS.forEach((type) => window.removeEventListener(type, stop));
  };
  const timer = window.setTimeout(stop, ANCHOR_SETTLE_MS);
  READER_SCROLL_EVENTS.forEach((type) => window.addEventListener(type, stop, { passive: true }));
  return stop;
}
